import { AppHomeComponent } from './home/home.component'

export const VIEWS = [AppHomeComponent]

export const coreViews = {
  home: AppHomeComponent,
}
